import {FC, useState} from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {TabPanel} from '../Core/UI';
import {observer} from 'mobx-react-lite';
import {useSession} from 'next-auth/react';
import {InternalUserRole} from '@amplify/athena-models';
import {LeadAssignmentPool} from './Leads/LeadAssignmentPool';
import EditXfers from '../Agent/EditXfers/EditXfers';
import {AssistContentEditor} from './AgentAssist/AssistContentEditor';

const Setting: FC = () => {
    const [tabIndex, setTabIndex] = useState(0);
    const session = useSession();
    const isApManager = (session?.data as any)?.roles?.includes(InternalUserRole.AP_MANAGER);

    return (
        <div style={{width: '100%'}}>
            <Tabs value={tabIndex} centered onChange={(_e, v) => setTabIndex(v)}>
                <Tab label="AA Lead assignment pool" />
                <Tab label="DEL Lead assignment pool" />
                <Tab label="BDS Transfer Form" />
                {isApManager && <Tab label="Agent Assist Content Editor" />}
            </Tabs>
            <TabPanel value={tabIndex} index={0}>
                <LeadAssignmentPool type={'AA'} />
            </TabPanel>
            <TabPanel value={tabIndex} index={1}>
                <LeadAssignmentPool type={'DEL'} />
            </TabPanel>
            <TabPanel value={tabIndex} index={2}>
                <EditXfers />
            </TabPanel>
            {isApManager && (
                <TabPanel value={tabIndex} index={3}>
                    <AssistContentEditor />
                </TabPanel>
            )}
        </div>
    );
};

export default observer(Setting);
